import { systemInfo } from '@/utils/systemInfo';

export interface AppInfo {
  type: number
  platform: string
}

/**
 * 项目类型
 * 0:未知，1：pc, 2：h5，3：安卓，4：ios, 5: 微信小程序， 6：微信浏览器，
 */
export function AppType(): AppInfo {
  let type: number = 0;
  let platform: string = '';

  // #ifdef APP-PLUS
  if (systemInfo.platform === 'android') {
    platform = 'Android';
    type = 3;
  }
  if (systemInfo.platform === 'ios') {
    platform = 'IOS';
    type = 4;
  }
  // #endif

  // #ifdef MP-WEIXIN
  platform = 'mp-weixin';
  type = 5;
  // #endif

  // #ifdef H5
  if (isWechatH5()) {
    platform = 'h5-weixin';
    type = 6;
  }
  else {
    platform = 'h5';
    type = 2;
  }
  // #endif

  return {
    platform,
    type,
  };
}

function isWechatH5() {
  // #ifdef H5
  return /MicroMessenger/i.test(navigator.userAgent);
  // #endif

  // #ifdef MP-WEIXIN
  return true;
  // #endif

  // #ifdef APP-PLUS
  return false;
  // #endif
}
